            import React from 'react';
            import {Typography, Box, Button, List, ListItem, ListItemText, TextField} from '@mui/material';
            import { styled } from "@mui/material/styles";

            const SlideContainer = styled(Box)`
              display: flex;
              flex-direction: column;
              height: 100%;
              padding: 20px 0;
            `;
            export const SlideWithImage = styled(Box)(({ theme }) => ({
                display: "flex",
                gap: 0,
                alignItems: "flex-start",
                width: "100%",
                minHeight: "50vh",

                [theme.breakpoints.down("lg")]: {
                    flexDirection: "column",
                },
            }));

            export const SlideImageContainer = styled(Box)`
              flex: 1;
              height:100%;
              display: flex;
              justify-content: center;
              align-items: center;
            `;

            export const SlideImage = styled(Image)`
              max-width: 100%;
              max-height: 460px;
              object-fit: contain;
              border-radius: 8px;
              box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
              transition: transform 0.2s ease;
            `;

            export const SlidePointsContainer = styled(Box)`
              flex: 1;
            `;

            export const SlideTitleContainer = styled(Box)`
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
                flex: 1;
            `;

            // Single point with larger image
            export const SlideSinglePointWithImage = styled(Box)`
              display: flex;
              flex-direction: column;
              gap: 30px;
              width: 100%;
            `;
            export const SlidePoint = styled(Box)`
              padding: 20px 0;
              border-radius: 8px;
              transition: transform 0.2s ease;
            `;

            export const PointTitle = styled(Typography)`
              margin-top: 0;
              margin-bottom: 10px;
              font-size: 18px;
              color: #000;
              font-weight: 600;
            `;

            export const PointText = styled(Typography)`
              margin: 0;
              color: #000;
              line-height: 1.6;
              font-size: 20px;
              text-align: left;
                user-select: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;

                /* Prevent drag */
                -webkit-user-drag: none;

                /* Disable context menu on right-click */
                pointer-events: auto;
            `;


            export const SinglePoint = styled(SlidePoint)`
              max-width: 100%;
              font-size: 1.1em;
            `;

            const SlideTitle = styled(Typography)(({ theme }) => ({
                width:'100%',
                textAlign: "left",
                marginBottom: "30px",
                fontSize: "35px",
                color: "#EE6D29",
                fontWeight: 700,
                position: "relative",
                paddingBottom: "15px",

                userSelect: "none",
                WebkitUserSelect: "none",
                MozUserSelect: "none",
                msUserSelect: "none",
                WebkitUserDrag: "none",
                pointerEvents: "auto",

                [theme.breakpoints.down("sm")]: {
                    fontSize: "23px",
                },
            }));


            export const SlideList = styled(Box)`
                  padding: 20px 0;
                  border-radius: 8px;
                   min-height: 47vh;
                user-select: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;

                /* Prevent drag */
                -webkit-user-drag: none;

                /* Disable context menu on right-click */
                pointer-events: auto;
                  
                  ul {
                    padding-left: 20px;
                    text-align: left;
                  }
                
                  li {
                    margin-bottom: 12px;
                    font-size: clamp(16px, 2vw, 21px);
                    color: #000;
                    line-height: 1.6;
                    list-style-type: disc;
                  }
                `;

            const ContentContainer = styled(Box)`
              flex: 1;
              display: flex;
              flex-direction: column;
            `;

            const ImagePlaceholder = styled(Box)`
              border-radius: 8px;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 75%;
              height: auto;
              min-height: 200px;
              margin: 16px auto;
              overflow: hidden;
              user-select: none;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              -webkit-user-drag: none;
            `;

            export const StepBlockContainer = styled(Box)(({ theme }) => ({
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "30px",
                marginBottom: "30px",
                [theme.breakpoints.down("lg")]: {
                    flexWrap: "wrap",
                    overflow: "auto",
                    justifyContent: "flex-start",
                    scrollSnapType: "y mandatory",
                    "-webkit-overflow-scrolling": "touch",
            },
            }));

            export const StepColumn = styled(Box)(({ theme }) => ({
                flex: "1 1 30%",
                maxWidth: "30%",
                minWidth: "200px",
                minHeight: "300px",
                borderRadius: "10px",
                padding: "16px",
                boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                [theme.breakpoints.down("sm")]: {
                    width: "250px",
                    maxWidth: "250px",
                    minWidth: "250px",
                },
            }));

            export const StepTitle = styled(Typography)`
              text-align: center;
              font-weight: 600;
                min-height: 140px;
                margin-bottom: 12px;
                line-height: 1.2;
                user-select: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;

                /* Prevent drag */
                -webkit-user-drag: none;

                /* Disable context menu on right-click */
                pointer-events: auto;
                color: #EE6D29;
                font-size: ${(props) => (props.iscondensed ? '22px' : '26px')};
            `;

            export const StepText = styled(Typography)`
                text-align: left;
              line-height: 1.5;
              color: #000;
                font-size: ${(props) => (props.iscondensed ? '18px' : '20px')};
                user-select: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;

                /* Prevent drag */
                -webkit-user-drag: none;

                /* Disable context menu on right-click */
                pointer-events: auto;
            `;

            export const SlideDescription = styled(Box)`
              line-height: 1.7;
              color: #000;
              font-size: 18px;
              padding: 20px 0;
              max-width: 100%;
              border-radius: 8px;
                min-height: 50vh;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                user-select: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;

                /* Prevent drag */
                -webkit-user-drag: none;

                /* Disable context menu on right-click */
                pointer-events: auto;
            `;

            export const VideoLayout = styled(Box)`
              display: flex;
              flex-direction: column;
              align-items: center;
              text-align: center;
              padding: 40px;
            `;

            export const ActivityContainer = styled(Box)`
              display: flex;
              flex-direction: row;
              gap: 40px;
              padding: 20px;
              max-width: 1100px;
              margin: 0 auto;
              align-items: flex-start;
            `;

            export const ActivityColumnContainer = styled(ActivityContainer)`
              flex-direction: column;
              align-items: center;
            `;

            export const ActivityLeft = styled(Box)`
              flex: 1;
              display: flex;
              flex-direction: column;
            `;

            export const ActivityRight = styled(Box)`
              flex: 1;
              display: flex;
              flex-direction: column;
              margin-top: 30px;
            `;

            export const ActivityHeader = styled(Box)`
              text-align: center;
              //max-width: 700px;
            `;

            export const ActivityTitle = styled(Typography)`
              font-size: 42px;
              color: #EE6D29;
              font-weight: 700;
              margin-bottom: 16px;
              text-align: left;
              margin-top: 0;
            `;

            export const ActivityPollTitle = styled(ActivityTitle)`
              text-align: center;
            `;

            export const ActivityContent = styled(Box)`
              text-align: left;  
              font-size: 18px;
              line-height: 1.6;
              color: #000;
              white-space: pre-line;
            `;

            export const JournalingTextArea = styled(Box)`
              width: 100%;
              min-height: 300px;
              padding: 16px;
              border: 2px solid #FF7676;
              border-radius: 8px;
              background-color: #fff;
              font-size: 16px;
              font-family: "Source Sans Pro", "Helvetica Neue", sans-serif;
              line-height: 1.5;
              resize: vertical;
              transition: border-color 0.2s ease;

              &:focus {
                outline: none;
                border-color: #FF7676;
                box-shadow: 0 0 0 3px rgba(255, 118, 118, 0.15);
              }

              &::placeholder {
                color: #a0aec0;
              }
            `;

            export const PledgeLayout = styled(Box)`
              display: flex;
              align-items: flex-start;
              justify-content: space-between;
              gap: 24px;
              width: 100%;
            `;

            export const LeftContent = styled(Box)`
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
            `;

            export const RightBox = styled(Box)`
              flex: 1;
              margin: 20px;
              margin-top: 60px;
              background-color: #0097b2;
              border-radius: 12px;
              padding: 24px;
              display: flex;
              flex-direction: column;
              align-items: center;
              text-align: center;
            `;

            export const IconWrapper = styled(Box)`
              margin-bottom: 16px;
              svg {
                font-size: 48px;
                color: #fff;
              }
            `;

            export const PledgeDescription = styled(Typography)`
              font-size: 16px;
              font-weight: 400;
              color: #fff;
              margin-bottom: 24px;
            `;

            export const SubmitButton = styled(Button)`
              align-self: center;
              padding: 12px 32px;
              background-color: #FF7676;
              color: white;
              border: none;
              border-radius: 8px;
              font-size: 16px;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.2s ease;
              margin-top: 16px;

              &:hover {
                background-color: #FF7676;
                transform: translateY(-1px);
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
              }

              &:active {
                transform: translateY(0);
              }

              &:disabled {
                background-color: #DDDDDD;
                cursor: not-allowed;
                transform: none;
              }
            `;

            export const SaveButton = styled(SubmitButton)`
              background-color: #FF7676;

              &:hover {
                background-color: #FF7676;
              }

              &:disabled {
                background-color: #DDDDDD;
              }
            `;

            export const Text = styled(Box)`
              text-align: center;
              font-weight: 600;
              color: #000000;
              margin: 10px auto;
              font-size: 22px;
            `;


            export const LinkInput = styled(TextField)`
              width: 60%;
              margin: 10px auto;
              padding: 16px;
              border: 2px solid #0097B2;
              border-radius: 8px;
              background-color: #fff !important;
              font-size: 16px;
              font-family: "Source Sans Pro", "Helvetica Neue", sans-serif;
              line-height: 1.5;
              resize: vertical;
              transition: border-color 0.2s ease;

              &:focus {
                outline: none;
                border-color: #0097B2;
                box-shadow: 0 0 0 3px rgba(255, 118, 118, 0.15);
              }

              &::placeholder {
                color: #a0aec0;
              }
            `;

            export const FileUploadButton = styled(Button)`
              padding: 10px 20px;
              background-color: #0097B2;
              border: none;
              border-radius: 6px;
              color: #ffffff;
              font-size: 18px;
              font-weight: 600;
              cursor: pointer;
              display: block;
              margin: 10px auto;
              width: 60%;
              transition: all 0.2s ease;
              &:hover {
                background-color: #0097B2;
              }
            `;

            // Poll/Quiz activity styles
            export const PollContainer = styled(Box)`
              display: flex;
              justify-content: center;
              flex-wrap: wrap;
              gap: 16px;
              width: 100%;
            `;

            export const PollOption = styled(Box)`
              flex: 0 1 calc(20% - 16px);
              min-width: 180px;
              max-width: 300px;
              padding: 16px;
              border: 2px solid #0097B2;
              border-radius: 8px;
              cursor: pointer;
              transition: all 0.2s ease;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: ${props => (props.selected ? '#0097B2' : '#fff')};
              color: ${props => (props.selected ? '#fff' : '#000')};
              font-size: 16px;
              font-weight: 500;
            
              &:hover {
                border-color: #0097B2;
              }
            `;

            export const PollOptionText = styled(Typography)`
              font-size: 16px;
              font-weight: 500;
            `;

            export const ActivityWrapper = styled(Box)`
              position: relative;
              width: 100%;
            `;

            export const DiscussionButton = styled(Button)`
              padding: 16px 40px;
              background-color: #0097B2;
              color: white;
              border: none;
              border-radius: 8px;
              font-size: 18px;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.2s ease;
              margin-top: 24px;
              margin-bottom: 16px;
              min-width: 200px;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
                
              /* Add icon styling */
              i {
                font-size: 16px;
              }
              `;


const SlideComponentV2 = ({ slide, highlightWord }) => {
  // console.log('SlideComponentV2 props:', slide);
  if (!slide) return null;

  const renderTitle = () => {
    if (!slide.SlideTitle) return null;
    return (
      <SlideTitle>
        {highlightWord ? highlightWord('title', slide.SlideTitle) : slide.SlideTitle}
      </SlideTitle>
    );
  };

  const renderTextWithId = (id, text, Component = PointText, extraProps = {}) => {
    if (text == null) return null;
    // Normalize text to string when possible
    let normalized = text;
    if (Array.isArray(normalized)) {
      // Flatten array to string of primitive / stringifiable values
      normalized = normalized
        .map(v => (typeof v === 'string' ? v : (v && typeof v === 'object' ? Object.values(v).filter(x=> typeof x === 'string').join(' ') : '')))
        .filter(Boolean)
        .join(' ');
    } else if (typeof normalized === 'object') {
      normalized = Object.values(normalized).filter(v => typeof v === 'string').join(' ');
    }
    if (typeof normalized !== 'string') {
      normalized = String(normalized);
    }
    if (!normalized.trim()) return null;
    return (
      <Component {...extraProps}>
        {highlightWord ? highlightWord(id, normalized) : normalized}
      </Component>
    );
  };

  const renderContent = () => {
    switch (slide.SlideLayout) {
      case 'TemplateGraphicAndText':
        return (
          <>
            <SlideWithImage>
              {slide.Images && slide.Images.length > 0 && (
                <SlideImageContainer>
                  <ImagePlaceholder>
                    <img
                      src={slide.Images[0]}
                      alt="Slide image"
                      style={{
                        width: '100%',
                        height: 'auto',
                        objectFit: 'contain',
                        borderRadius: '4px',
                        pointerEvents: 'none',
                        WebkitUserDrag: 'none',
                      }}
                    />
                  </ImagePlaceholder>
                </SlideImageContainer>
              )}
              <SlidePointsContainer>
                <SlidePoint>
                  {renderTitle()}
                  {renderTextWithId('content_0', slide.SlideContent)}
                </SlidePoint>
              </SlidePointsContainer>
            </SlideWithImage>
          </>
        );

      case 'TemplateSessionStart':
        return (
          <SlideWithImage>
            {slide.Images && slide.Images.length > 0 && (
              <SlideImageContainer>
                <ImagePlaceholder>
                  <img
                    src={slide.Images[0]}
                    alt="Slide image"
                    style={{
                      width: '100%',
                      height: 'auto',
                      objectFit: 'contain',
                      borderRadius: '4px',
                      pointerEvents: 'none',
                      WebkitUserDrag: 'none',
                    }}
                  />
                </ImagePlaceholder>
              </SlideImageContainer>
            )}
            <SlideTitleContainer>
              <SlidePoint>
                {renderTitle()}
              </SlidePoint>
            </SlideTitleContainer>
          </SlideWithImage>
        );

      case 'TemplateList':
        return (
          <>
            <SlideList>
              {renderTitle()}
              <ul>
                {Array.isArray(slide.SlideContent) && slide.SlideContent.map((item, idx) => (
                  <li key={idx}>
                    {renderTextWithId(`content_${idx}`, item)}
                  </li>
                ))}
              </ul>
            </SlideList>
          </>
        );

      case 'TemplateLongText':
        return (
          <SlideDescription>
            {renderTitle()}
            {renderTextWithId('content_0', slide.SlideContent)}
          </SlideDescription>
        );

      case 'TemplateStepBlock': {
        const isCondensed = Array.isArray(slide.SlideContent) && slide.SlideContent.length > 3;
        return (
          <SlideDescription>
            {slide.SlideTitle && (
              <SlideTitle style={{ textAlign: 'center' }}>
                {highlightWord ? highlightWord('title', slide.SlideTitle) : slide.SlideTitle}
              </SlideTitle>
            )}
            <StepBlockContainer>
              {Array.isArray(slide.SlideContent) &&
                slide.SlideContent.map((step, idx) => (
                  <StepColumn key={idx}>
                    {renderTextWithId(`content_${idx}_title`, step.Title, StepTitle, { iscondensed: isCondensed })}
                    {renderTextWithId(`content_${idx}_text`, step.Text, StepText, { iscondensed: isCondensed })}
                  </StepColumn>
                ))}
            </StepBlockContainer>
          </SlideDescription>
        );
      }

      case 'PledgeTemplate':
        return (
          <PledgeLayout>
            <LeftContent>
              {renderTitle()}
              {renderTextWithId('content_0', slide.SlideContent)}
            </LeftContent>

            <RightBox>
              <IconWrapper />
              <PledgeDescription>{slide.SlidePledgeContent}</PledgeDescription>
              <SubmitButton>I pledge</SubmitButton>
            </RightBox>
          </PledgeLayout>
        );

      case 'VideoTemplate':
        return (
          <VideoLayout>
            {renderTitle()}
            {renderTextWithId('content_0', slide.SlideContent)}
          </VideoLayout>
        );

      case 'JOURNALING_SELF_REFLECTION_ACTIVITY':
        return (
          <ActivityContainer>
            <ActivityLeft>
              {renderTitle()}
              {renderTextWithId('content_0', slide.SlideContent, ActivityContent)}
            </ActivityLeft>
            <ActivityRight>
              <JournalingTextArea placeholder="Start writing your reflection here..." />
              <SaveButton>Save</SaveButton>
            </ActivityRight>
          </ActivityContainer>
        );

      case 'SHARE_WORK_FILE_ACTIVITY':
        return (
          <ActivityContainer>
            <ActivityLeft>
              {renderTitle()}
              {renderTextWithId('content_0', slide.SlideContent, ActivityContent)}
            </ActivityLeft>
            <ActivityRight>
              <LinkInput
                type="url"
                placeholder="Paste your shareable link here (e.g., Google Drive, Dropbox, etc.)"
              />
              <SubmitButton>Submit</SubmitButton>
            </ActivityRight>
          </ActivityContainer>
        );

      case 'POLL_QUIZ_ACTIVITY':
        return (
          <ActivityColumnContainer>
            <ActivityHeader>
              {renderTitle()}
              {renderTextWithId('content_0', slide.SlideContent, ActivityContent)}
            </ActivityHeader>
            <PollContainer>
              {Array.isArray(slide.Options) && slide.Options.map((option, idx) => (
                <PollOption key={idx}>
                  <PollOptionText>{option}</PollOptionText>
                </PollOption>
              ))}
            </PollContainer>
            <SubmitButton>Submit</SubmitButton>
          </ActivityColumnContainer>
        );

        case 'DISCUSSION_ACTIVITY':
        return (
              <ActivityWrapper>
                  <ActivityColumnContainer>
                      {/* Header */}
                      <ActivityHeader>
                          <ActivityTitle>
                              {renderTitle()}
                          </ActivityTitle>
                          <ActivityContent> {renderTextWithId('content_0', slide.SlideContent, ActivityContent)}</ActivityContent>
                      </ActivityHeader>

                      {/* Discussion Button */}
                      <DiscussionButton>
                          "Let's Talk about it"
                      </DiscussionButton>
                  </ActivityColumnContainer>
              </ActivityWrapper>
        );

      default:
        return (
          <Typography variant="body1" color="error">
            Unsupported slide layout: {slide.SlideLayout}
          </Typography>
        );
    }
  };

  return (
    <SlideContainer>
      <ContentContainer>{renderContent()}</ContentContainer>
    </SlideContainer>
  );
};

export default SlideComponentV2;